import React, { useEffect, useRef, useState } from "react";
import blog_ver_mas from "../../assets/01_Home/Blog_CTA-Thumbnail.webp";
import { Link } from "react-router-dom";

/*eslint-disable */

const blogs: any = [
  {
    name: "Hyundai y la huella de carbono",
    category: "Noticias",
    asset: "./assets/01_Home/comunidad-hyundai-huella-carbono.webp",
  },
  {
    name: "Nombre de un testimonio en dos líneas",
    category: "Recomendaciones",
    asset: "./assets/01_Home/comunidad-hyundai-testimonio-doble-linea.webp",
  },
  {
    name: "Las ventajas de tener tu propio hyundai eléctrico en ...",
    category: "Comunidad Hyundai",
    asset: "./assets/01_Home/comunidad-hyundai-ventajas-vehiculo-electrico.webp",
  },
];

interface BlogComponentProps {
  newsForCategories: any;
}

const BlogComponent: React.FC<BlogComponentProps> = ({ newsForCategories }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else if (entry.boundingClientRect.top > 0) {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className="blog-home-component">
      <h2 className={`title-blog-home-component`} ref={ref}>
        Novedades y comunidad Hyundai
      </h2>
      <div className={`items-blog-home-component`}>
        {newsForCategories.map((item: any, index: number) => (
          <Link
            key={index}
            to={`/noticias/${item?.category_id}/${item?.slug}`}
            className={`item-blog-home-component ${isVisible ? "visible" : ""}`}
          >
            <img
              src={`https://manager.hyundaicolombia.co/${item?.media_portrait?.url}`}
              alt={item?.title || "Imagen de la noticia"}
            />
            <div className="descripcion-item-blog-home-component">
              <h4 className="category-descripcion-item-blog-home-component">
                {item.category}
              </h4>
              <h3 className="name-descripcion-item-blog-home-component">
                {item.title}
              </h3>
            </div>
          </Link>
        ))}
        <Link to={"/noticias"} className="item-vermas-blog-home-component">
          <img src={blog_ver_mas} alt="Ver más noticias sobre Hyundai" />
          <h3 className="mascara-item-blog-home-component">
            Ver más noticias <br />
            sobre Hyundai
          </h3>
        </Link>
      </div>
    </div>
  );
};

export default BlogComponent;
